/**
 * apps/battle/client/src/terminal/screens/EmptyClusterScreen.tsx
 * Shown when a cluster has no questions yet (regularBattlesTotal === 0).
 * No crash, no panic — back to title.
 */
import { TerminalFrame } from '../components/TerminalFrame.js';
import { KeyBar, type KeyBarItem } from '../components/KeyBar.js';
import { useKeyboard } from '../hooks/useKeyboard.js';
import type { ClusterState } from '../../api.js';

interface Props {
  cluster: ClusterState;
  onBackToTitle: () => void;
}

export function EmptyClusterScreen({ cluster, onBackToTitle }: Props) {
  useKeyboard([
    { key: 'Enter', handler: onBackToTitle },
    { key: 'b', handler: onBackToTitle },
  ]);

  const title = (
    <>
      ECONQUEST <span className="tm-text--dim">{'\u2500'}</span> CLUSTER {cluster.clusterId}
    </>
  );
  const keybar: KeyBarItem[] = [
    { label: 'B', description: 'back to title', onActivate: onBackToTitle },
  ];

  return (
    <TerminalFrame title={title} keybar={<KeyBar items={keybar} />}>
      <div className="tm-section">
        <div className="tm-h1">{cluster.fullName}</div>
        <div className="tm-text"><span className="tm-prompt">{'>'}</span> No questions available yet.</div>
        <div className="tm-text tm-text--dim" style={{ marginTop: '0.6rem' }}>
          Content is being authored. Check back soon — or try another cluster.
        </div>
      </div>
    </TerminalFrame>
  );
}
